// Mock data for Aaron Choi Personal Training Website

export const heroData = {
  title: "Transform Your Body, Transform Your Life",
  subtitle: "Aaron Choi - Personal Trainer & Wellness Specialist in Portsmouth",
  description: "Achieve your fitness goals with expert guidance and personalized training programs across Portsmouth and surrounding areas.",
  ctaText: "Contact Me",
  phone: "+447787166065"
};

export const aboutData = {
  name: "Aaron Choi",
  story: `I know how it feels to not be happy with yourself.

When I was younger, I had bad confidence issues which mainly stemmed from how I looked. This negatively impacted many parts of my life: from my social life to my dating life.

Once I started to see some progress in the gym, everything changed. It honestly helped turn me from a timid young boy, to a confident young man.

I not only experienced first hand the impact getting in shape can have on my own life, but I've also witnessed this with the 100's of clients that I've trained in my 9 years of PTing.

The gym changed my life, and all of theirs. I'd love to help you experience this too.`,
  specialistAreas: [
    "Weight loss",
    "Muscle tone and development",
    "Body fat reduction",
    "Body confidence"
  ],
  qualifications: [
    "Level 2 Gym Instructor",
    "Level 3 Personal Trainer",
    "Level 3 Exercise Referral",
    "Level 3 Sports and Conditioning",
    "BSc Sport and Exercise Science",
    "Raynor Massage Qualified"
  ],
  experience: "9 years of personal training",
  clientsHelped: "100s of clients transformed"
};

export const servicesData = [
  {
    id: 1,
    title: "Personal Training in Hampshire",
    description: "One-on-one customized training programs designed to help you reach your specific fitness goals. Whether you're looking to lose weight, build muscle, or improve overall fitness across Southampton, Portsmouth, or Winchester.",
    features: [
      "Customized workout plans",
      "Nutrition guidance",
      "Progress tracking",
      "Ongoing support"
    ],
    image: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/6zeyaqh2_WhatsApp%20Image%202026-03-18%20at%2014.51.44.jpeg",
    altText: "Aaron Choi personal training session in Hampshire gym"
  },
  {
    id: 2,
    title: "Sports Massage Therapy",
    description: "Professional sports and recovery massage to enhance your performance, prevent injuries, and accelerate recovery. Perfect for athletes and fitness enthusiasts in Hampshire.",
    features: [
      "Sports massage",
      "Deep tissue therapy",
      "Recovery sessions",
      "Injury prevention"
    ],
    image: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/gyv3yh3q_openart-099fdfd4-6f5d-40dd-9ee0-1587fa143ab0.jpeg",
    altText: "Aaron Choi sports massage therapy session"
  },
  {
    id: 3,
    title: "Fitness Seminars & Workshops",
    description: "Educational seminars covering fitness, nutrition, and wellness topics. Learn from industry experts and guest speakers in an interactive environment across Hampshire.",
    features: [
      "Expert guest speakers",
      "Interactive workshops",
      "Nutrition education",
      "Fitness strategies"
    ],
    image: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/ys5j6k22_WhatsApp%20Image%202026-03-18%20at%2014.52.19.jpeg",
    altText: "Aaron Choi fitness seminar with guest speaker"
  },
  {
    id: 4,
    title: "Wellness Retreats",
    description: "Immersive wellness experiences combining fitness, nutrition, mindfulness, and recovery. Transform your lifestyle in a supportive environment.",
    features: [
      "All-inclusive packages",
      "Group training sessions",
      "Nutrition workshops",
      "Mindfulness practices"
    ],
    image: "https://images.unsplash.com/photo-1534258936925-c58bed479fcb",
    altText: "Wellness retreat fitness session"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Roger",
    service: "Personal Training",
    rating: 5,
    text: "Having tried a range of personal trainers over the years, i can honestly say that Aaron has achieved more for me in a matter of months that all of the others who have taken years - and i do mean years."
  },
  {
    id: 2,
    name: "Michelle",
    service: "Personal Training",
    rating: 5,
    text: "The dedication that Aaron invests in you achieving your goals is second to none. Aaron is not just supportive in the gym as he is always on hand to offer advice outside of sessions, whether it be in person, text or email. He really does go above and beyond"
  },
  {
    id: 3,
    name: "Hannah",
    service: "Personal Training",
    rating: 5,
    text: "Personal Training with Aaron is one of the best things that I've started doing! My strength and confidence have grown so much and I couldn't be happier. He's also very professional and easy to get along with!"
  },
  {
    id: 4,
    name: "Jo",
    service: "Personal Training",
    rating: 5,
    text: "I have tried many different fitness classes (pole, zumba, bootcamp...) and have been going independantly to the gym for years. But no one has got me the results that Aaron has! He became my PT when I was at my worst. I was so demotivated but Aaron not only transformed my body, but my way of thinking too! I would 100% recommend Aaron!!"
  },
  {
    id: 5,
    name: "Chelsea",
    service: "Personal Training",
    rating: 5,
    text: "He is an amazing PT definitely recommend Aaron if your looking for a genuinely nice guy, easy to get along with and has your best interest at heart go for Aaron as your pt he always makes you hit your goals."
  },
  {
    id: 6,
    name: "Elliott",
    service: "Personal Training",
    rating: 5,
    text: "Since working with Aaron my whole life has changed! He has completely motivated and pushed me to achieve goals which I thought were impossible. He gives me accountability for my workout sessions and is a caring and understanding coach who is solely focused on improving me and hitting my goals. I can't recommend this guy enough!"
  },
  {
    id: 7,
    name: "Nigel",
    service: "Personal Training",
    rating: 5,
    text: "I have known and worked with Aaron in the gym for nearly a year now. He's very approachable, knowledgeable and….very patient! I have gained enormously from his experience which he has used to tailor a workout regime that pushes me, and helps me build up to compete in the sports I love. I can't recommend his services highly enough."
  },
  {
    id: 8,
    name: "Reuben",
    service: "Personal Training",
    rating: 5,
    text: "Aaron is a fantastic trainer and he will take care of designing a workout routine, giving nutrition advice as well as general encouragement during sessions. Since I started training with him I've improved my functional strength and my health so much. Super great guy too, 100% recommend him as a PT!"
  },
  {
    id: 9,
    name: "Lottie",
    service: "Sports Massage",
    rating: 5,
    text: "I recently had a sports massage focusing on my back, neck and shoulders, and I honestly couldn't recommend it more highly. From start to finish, the experience was professional, welcoming and tailored exactly to what I needed. Aaron really took the time to understand where I was holding tension and explained what they were working on throughout the session."
  },
  {
    id: 10,
    name: "Maria",
    service: "Personal Training",
    rating: 5,
    text: "Always professional and respectful. Friendly and easy going, made me feel like I was exercising with a friend and not a professional trainer. Always happy to work around my schedule, which is really appreciated and very helpfull. I'm really happy I chose you as my trainer! I would totally recommend Aaron to all my friends!"
  },
  {
    id: 11,
    name: "Jess B",
    service: "Seminars",
    rating: 5,
    text: "Aaron is a down to earth PT, he recently hosted a seminar that I attended and took some great advice away with me, highly recommend, if you're looking for a great PT, or a sports massage or even a seminar then contact Aaron"
  },
  {
    id: 12,
    name: "Emma",
    service: "Personal Training",
    rating: 5,
    text: "Have used Aaron as a PT in the past and always been a great support especially with health conditions, he explain things in a way that's easy to understand and keep up with fitness by yourself too"
  },
  {
    id: 13,
    name: "Jess G",
    service: "Personal Training",
    rating: 5,
    text: "Aaron is a great PT who always offers a varied session. During my time with him I saw some big changes in my overall strength and also, my approach to working out - that even a short session is better than nothing and that as long as you're fueling your body right, your progress will soar - I saw these results first-hand."
  },
  {
    id: 14,
    name: "Lee",
    service: "Personal Training",
    rating: 5,
    text: "Aaron was a top PT throughout all of the time I trained with him, which was around 18 months. As a complete novice, he helped me in all aspects of my training, writing great training plans and advising me on my nutrition. He helped me achieve my fitness goals and got me in the best shape of my life. I would 100% recommend Aaron!"
  },
  {
    id: 15,
    name: "Will",
    service: "Online Training",
    rating: 5,
    text: "Working online with Aaron has been a huge help to me. In the space of two months with some extra guidance and a bit of a push I've already started making progress and have gained 7kg. One of my goals was to put mass back on again and i've made a great start at that quite quickly working with Aaron."
  },
  {
    id: 16,
    name: "Chris",
    service: "Personal Training",
    rating: 5,
    text: "Aaron is a great PT who helped me reach my fitness goals. He gave me a training regime structure and he gave me confidence in the gym. Our sessions were very easy going and he made going to the gym a fun and social time rather than feeling like it was a tick box exercise. I would highly recommend him"
  },
  {
    id: 17,
    name: "Lewis",
    service: "Personal Training",
    rating: 5,
    text: "I started training with Aaron about 8-9 months ago as I felt like I wasn't getting anywhere with training and losing confidence in myself. Aarons knowledge and encouragement helped me get to where I wanted to be and allowed me to finally get myself on track. Couldn't thank him enough for everything he has done for me!"
  },
  {
    id: 18,
    name: "Simone",
    service: "Seminars",
    rating: 5,
    text: "Aaron makes fitness fun and is there to guide with technique and gives encouragement, when required. I attended Aaron's seminar this summer, where I was able to pick up some practical tips to keep me motivated in my own health/ fitness/ wellbeing journey plus enjoyed getting to know him more by hearing his journey. Keep up the great work Aaron!"
  },
  {
    id: 19,
    name: "Arianne",
    service: "Personal Training",
    rating: 5,
    text: "I've been training with Aaron for just over a year and I'm looking and feeling better now than I have done for years. He's really helped me break the cycle of going to the gym for a couple of months and then giving up with minimal results. With his guidance I've gained confidence in the gym, learnt lifting technique and have been gently pushed to achieve more."
  },
  {
    id: 20,
    name: "Ethan",
    service: "Personal Training",
    rating: 5,
    text: "From March to July this year, I trained under Aaron's guidance at my local gym. Aaron was very patient and explained each exercise as I progressed. I went from feeling nervous and unsure how to use anything in the gym to now feeling very confident. Thanks to his personal training, I now feel fitter and stronger."
  },
  {
    id: 21,
    name: "Hattie",
    service: "Personal Training",
    rating: 5,
    text: "Really knows his stuff! Really approachable PT and helped me loads during my cancer treatment. Listens to what I needed and set up realistic programs to help me reach my goals."
  },
  {
    id: 22,
    name: "Salim",
    service: "Personal Training",
    rating: 5,
    text: "In our introductory session I explained I wasn't enjoying the gym anymore so Aaron assessed my current routine and pointed out the inefficiency, showing me some new exercises. His recommendations were tailored to my personal goals and worked realistically with my lifestyle. Super knowledgeable and super supportive!"
  },
  {
    id: 23,
    name: "Alex F",
    service: "Personal Training",
    rating: 5,
    text: "Aaron is a fantastic PT, he is supportive, encouraging and makes the session fun. I would recommend Aaron to anyone who is looking to gain confidence in the gym"
  },
  {
    id: 24,
    name: "Lloyd",
    service: "Sports Massage",
    rating: 5,
    text: "I had a great massage to help with some ongoing back pain, and it really made a difference. Aaron worked through the tension in my muscles with just the right pressure, and I felt noticeably looser and more comfortable afterwards. It was a proper reset for my back, I highly recommend if you're dealing with tightness or pain."
  },
  {
    id: 25,
    name: "Tom",
    service: "Sports Massage",
    rating: 5,
    text: "I had a fantastic massage with Aaron Choi that really helped relieve the tension and knots in my shoulders. He was incredibly attentive and focused exactly where I needed it most. I walked out feeling lighter, looser, and much more relaxed. Highly recommend Aaron."
  },
  {
    id: 26,
    name: "Sadie",
    service: "Personal Training",
    rating: 5,
    text: "I've had PT with Aaron for 7 months, he is very knowledgeable & likes to build your knowledge in the gym to help you achieve your goals. He pushes you effectively & realistically in every session."
  },
  {
    id: 27,
    name: "Rhys",
    service: "Seminars",
    rating: 5,
    text: "I attended one of Aaron's seminars in north harbour PureGym earlier this year and it was excellent. Aaron is really knowledgeable and down to earth. He's overcome adversity in his life and his journey is inspirational. He really understands that life can be hard and finding time for your health and wellbeing can be difficult."
  },
  {
    id: 28,
    name: "Jess W",
    service: "Personal Training",
    rating: 5,
    text: "Aaron is a genuine, knowledgeable and understanding PT. He has helped me massively with my confidence in areas I was struggling with as well as pushed me to beat my personal bests. Highly recommend as he will keep you consistent, motivated and help achieve your goals in whatever they may be."
  },
  {
    id: 29,
    name: "Kyle",
    service: "Personal Training",
    rating: 5,
    text: "I PT'd with Aaron for around 3 years and he was great. Aaron takes the time to listen to you and sets up training plans and goals accordingly. He's genuinely interested in your improvement and takes a holistic approach to training. If you're unsure of what workouts to do or are perhaps nervous in the gym, Aaron is your guy."
  },
  {
    id: 30,
    name: "Liv",
    service: "Personal Training",
    rating: 5,
    text: "I've only had a couple of sessions with Aaron but he's super good at making you feel at ease and comfortable in the environment. He's always got great advice and definitely makes you work for whatever your goal is. I've enjoyed working with him so far, he's dead friendly and not one of those PTs whose ego matters more than his clients. I'd recommend him to anyone!"
  }
];

export const transformationsData = [
  {
    id: 1,
    clientName: "Owen",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/osnwu44f_1.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/osnwu44f_1.png",
    duration: "12 weeks",
    achievement: "Built muscle and strength",
    goal: "To build muscle and strength"
  },
  {
    id: 4,
    clientName: "Jim",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/1gfeiddq_4.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/1gfeiddq_4.png",
    duration: "24 weeks",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 5,
    clientName: "Kyle",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/q9b3z9wg_5.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/q9b3z9wg_5.png",
    duration: "16 weeks",
    achievement: "Built muscle and definition",
    goal: "To build muscle"
  },
  {
    id: 6,
    clientName: "Lucy",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/63m0ki02_6.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/63m0ki02_6.png",
    duration: "18 weeks",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 7,
    clientName: "Lee",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/rzvbv5tm_7.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/rzvbv5tm_7.png",
    duration: "22 weeks",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 9,
    clientName: "Alicia",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/eh1a5w0a_9.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/eh1a5w0a_9.png",
    duration: "20 weeks",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 11,
    clientName: "Elliott",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/wa41e2dv_11.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/wa41e2dv_11.png",
    duration: "20 weeks",
    achievement: "Trimmed down and built muscle and strength",
    goal: "To trim down, and build muscle and strength"
  },
  {
    id: 12,
    clientName: "Will",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/yhlegxhm_12.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/yhlegxhm_12.png",
    duration: "18 weeks",
    achievement: "Built muscle and strength",
    goal: "To build muscle and strength"
  },
  {
    id: 14,
    clientName: "Pheobe",
    beforeImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/jol04o24_14.png",
    afterImage: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/jol04o24_14.png",
    duration: "16 weeks",
    achievement: "Built muscle and strength",
    goal: "To build muscle and strength"
  },
  {
    id: 15,
    clientName: "Rosie",
    beforeImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/g1id7ppv_2.png",
    afterImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/g1id7ppv_2.png",
    duration: "",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 16,
    clientName: "Chris",
    beforeImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/t41ieje1_10.png",
    afterImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/t41ieje1_10.png",
    duration: "",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  },
  {
    id: 17,
    clientName: "Lewis",
    beforeImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/x9leu2q0_8.png",
    afterImage: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/x9leu2q0_8.png",
    duration: "",
    achievement: "Dropped body fat and toned up",
    goal: "To drop body fat and tone up"
  }
];

export const seminarGallery = [
  {
    id: 1,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/ip1cd6lq_76098D1D-053F-434F-86AC-2973A6928995.JPEG",
    title: "How to overcome mental barriers in your fitness journey",
    speaker: "Elliott Titcombe",
    date: "27th May 2023",
    description: "Elliott used to be obese, and his problematic health was really interfering with his life. Eventually, he said enough was enough, and started his fitness journey. In this journey, he had to learn to say \"no\" to people, overcome anxiety, and battle with self doubt and self sabotage. Now, he's in the best shape of his life. In this seminar, Elliott and I explored how mental barriers can interfere with your progress, and how to limit their impacts."
  },
  {
    id: 2,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/5zjndfv1_How%20to%20overcome%20your%20vices.jpg",
    title: "How to overcome your vices to become your best self",
    speaker: "Rae Carter",
    date: "8th July 2023",
    description: "Rae Carter almost died several times from alcoholism. At worst, he was drinking an entire bottle of spirit a night, and was coughing up blood while his loved ones tried desperately to stop him. Rae eventually got clean, and is now a Purple belt in Brazilian Jiu Jitsu. In this seminar, Rae and I spoke about how vices can ruin your life, and the best ways to stop that from happening."
  },
  {
    id: 3,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/tia4qeyh_FullSizeRender.jpg",
    title: "The Blueprint to hitting your new years goals",
    speaker: "Ben Bealey",
    date: "13th January 2024",
    description: "Ben Bealey is a strength and conditioning coach, as well as head coach for Fordingbridge rugby club. He has a wealth of knowledge and has helped so many people reach peak physical health and fitness through proper structure, planning and strategy. In this seminar, Ben gave valuable insights on how to get into your best shape ever."
  },
  {
    id: 4,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/n5uapcef_How_getting_in_shape_will_change_your_life.jpg",
    title: "How getting in shape will change your life",
    speaker: "Chris Robey",
    date: "12th July 2025",
    description: "This seminar was an emotional rollercoaster. Earlier in this life, Chris spiralled massively after the death of his dad as a child. This lead him to taking huge amounts of drugs, as he developed an idea that if he ever become happy again, that feeling was just going to be taken away from him again. Chris eventually managed to turn his life around through fitness. Now, he is a highly accomplished martial artist and runs a successful online coaching business. Together, Chris and I spoke about how powerful fitness is at turning your life around. And no matter what problem that you're suffering with, it can truely help change things for you."
  },
  {
    id: 5,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_transform-with-aaron/artifacts/ijfhj9ab_Becoming%20Unstoppable%20The%20Emotional%20Fitness%20Workshop.JPG",
    title: "Becoming Unstoppable: The Emotional Fitness Workshop",
    speaker: "Steve Afshar",
    date: "8th February 2026",
    description: "Steve Afshar is the owner of the company \"The BluePrint for Success.\" He normally works with high earning CEO's to help take them to that next level by eliminating problematic thoughts and behaviours. His wealth of knowledge, expertise and qualifications mean he has a powerful and inspirational presence. In this seminar, Steve got guests to reflect on their past, to help them realise why their problematic behaviours exist in the first place, and how to rewire their thinking to improve their lives."
  }
];

export const seminarIntro = {
  title: "Personal Development Seminars",
  description: "I host seminars to create opportunities for growth and learning through storytelling, interactive workshops and open discussion. Each seminar brings a diverse range of guest speakers - from individuals who have rebuilt their lives from addiction, to respected leaders who help break problematic behaviours. No matter which guest speaker I pick to come in, they provide value. While the topics vary, every seminar is guided by a clear and deliberate purpose: personal development. I started organising and hosting these to challenge perspectives, encourage reflection, and provide education to encourage physical and mental change."
};

export const faqData = [
  {
    id: 1,
    question: "How do I get started with personal training in Hampshire?",
    answer: "Getting started is easy! Simply reach out through the contact form, WhatsApp, or phone. We'll schedule a free consultation to discuss your goals, assess your current fitness level, and create a personalized plan tailored to your needs."
  },
  {
    id: 2,
    question: "What should I expect in the first session?",
    answer: "Your first session includes a comprehensive fitness assessment, discussion of your goals and any limitations, and an introduction to proper exercise techniques. We'll also outline your personalized training program and answer any questions you have."
  },
  {
    id: 3,
    question: "Do you offer online coaching?",
    answer: "Yes! I offer both in-person and online coaching programs. Online coaching includes customized workout plans, nutrition guidance, regular check-ins, and ongoing support through video calls and messaging."
  },
  {
    id: 4,
    question: "What areas in Hampshire do you cover?",
    answer: "I provide personal training services across Hampshire including Southampton, Portsmouth, Winchester, Basingstoke, Eastleigh, Fareham, Andover, and Fleet. I also offer online coaching for clients throughout the UK."
  },
  {
    id: 5,
    question: "How long are the training sessions?",
    answer: "Standard personal training sessions are 60 minutes. This allows enough time for a proper warm-up, focused training, and cool-down. Session length can be adjusted based on your specific needs and goals."
  },
  {
    id: 6,
    question: "What is sports massage and how can it help me?",
    answer: "Sports massage is a therapeutic treatment that helps improve performance, prevent injuries, and accelerate recovery. It's beneficial for athletes and fitness enthusiasts, helping to reduce muscle tension, improve flexibility, and enhance overall physical condition."
  },
  {
    id: 7,
    question: "How often should I train?",
    answer: "Training frequency depends on your goals, fitness level, and schedule. Most clients see excellent results with 2-4 sessions per week. During our consultation, we'll determine the optimal frequency for your specific situation."
  },
  {
    id: 8,
    question: "Tell me more about the wellness retreats",
    answer: "Wellness retreats are immersive experiences designed to kickstart your fitness journey or take it to the next level. They combine intensive training, nutrition education, mindfulness practices, and recovery sessions in a supportive group environment. Perfect for those looking for a transformative experience."
  },
  {
    id: 9,
    question: "Do you provide nutrition guidance?",
    answer: "Absolutely! Nutrition is a crucial component of achieving your fitness goals. I provide personalized nutrition guidance as part of all training programs, helping you understand how to fuel your body properly for optimal results."
  },
  {
    id: 10,
    question: "What qualifications do you have?",
    answer: "I hold a BSc in Sport and Exercise Science, Level 3 Personal Trainer certification, Level 3 Exercise Referral, Level 3 Sports and Conditioning, and Level 2 Gym Instructor qualifications. I'm fully qualified to help you achieve your fitness goals safely and effectively."
  }
];

export const trainingPhotos = [
  "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/59kcqnc9_IMG_3727.JPG",
  "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/bkiqrn8e_IMG_3434.JPG",
  "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/0g7cp2ap_IMG_0334.JPG",
  "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/odmcs7zx_IMG_0555.jpg"
];

export const massageData = {
  title: "Raynor Massage & Cupping Therapy",
  description: "I became qualified in Raynor massage because I knew feeling your best goes beyond physical strength and confidence. Training places demands on the body, and daily life adds even more layers of stress, tension and fatigue. Massage is powerful, as it creates a space for the body to rest and recover. It allows me to support people not just in terms of how they move, but how they feel. When the body feels and functions better, everything else improves, and that's why massage is an essential piece of work that I do.",
  cuppingDescription: "I also offer cupping therapy, which is amazing at promoting blood flow to an area. This then heals the area by providing essential nutrients and oxygen. Recently, cupping has become popular, with good reason. It's an extremely effective massage alternative, and it also only takes a fraction of the time.",
  pricing: [
    { duration: "30 minutes", price: "£25", service: "Sports Massage" },
    { duration: "60 minutes", price: "£45", service: "Sports Massage" },
    { duration: "Session", price: "£25", service: "Cupping Treatment", note: "£10 first-time client offer" }
  ],
  images: [
    {
      url: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/jv7xcebe_openart-099fdfd4-6f5d-40dd-9ee0-1587fa143ab0.jpeg",
      alt: "Aaron Choi performing sports massage therapy"
    }
  ],
  cuppingImage: {
    url: "https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/2unsya76_jakub-klucky-jwCx_YPY7so-unsplash.jpg",
    alt: "Cupping therapy treatment session"
  }
};

export const pricingData = {
  personalTraining: {
    startingPrice: "£120 a month"
  },
  massage: massageData.pricing
};

export const retreatData = {
  title: "The Emotional Reset Retreat",
  dates: "5–8 November 2026",
  location: "Exmoor, Somerset",
  tagline: "Four days of rest, nourishment, fun, laughter and rejuvenation",
  description: "This retreat is for anyone who feels like they need to pause. Not to overhaul their life. Not to \"fix\" themselves. Just to rest, reset, and feel like themselves again.",
  fullDescription: "From 5–8 November, we'll be staying in a beautiful farmhouse tucked away in a quiet Exmoor valley, surrounded by rolling countryside and complete peace. With a private lake on the land and no pressure to be anything other than human, this retreat is about mental and emotional rejuvenation—through movement, stillness, connection, and fun.",
  venue: {
    description: "Our home for four days is a large, cosy farmhouse set deep in the countryside, away from noise, schedules, and distraction.",
    features: [
      "Hidden valley location for true peace and quiet",
      "Beautiful countryside walks right outside the door",
      "A private lake on the land",
      "Hot tub for slow, chilled evenings",
      "Warm, communal spaces designed for connection and comfort"
    ],
    note: "This is the kind of place that instantly slows your nervous system the moment you arrive."
  },
  forWho: {
    title: "This retreat is for everyone",
    subtitle: "No fitness requirements. No restrictions. No pressure to \"perform\".",
    ideal: [
      "You feel mentally overloaded or emotionally drained",
      "You've been putting yourself last for a while",
      "You want rest without isolation",
      "You crave connection, calm, laughter, and space",
      "You want to leave feeling lighter, clearer, and re-energised"
    ],
    note: "You don't need experience with retreats, fitness, tarot, or sound baths—just an openness to rest and reset."
  },
  activities: {
    title: "What's Included",
    description: "Every activity has been chosen to support mental and emotional reset, while still being enjoyable and relaxed.",
    list: [
      "Gentle mobility mornings to wake up the body",
      "Countryside walks at an easy, enjoyable pace",
      "Sound bath for deep nervous-system relaxation",
      "Tarot card readings (optional, just for fun and insight)",
      "Massages to fully unwind",
      "Chilled hot tub evenings under the stars",
      "Pizza-making night",
      "Games nights and relaxed social time"
    ],
    note: "Nothing is compulsory. You're always free to join in—or rest when you need to."
  },
  meals: {
    title: "All Meals Included",
    description: "All breakfasts, lunches, and dinners are included.",
    qualities: [
      "High quality",
      "Nourishing and satisfying",
      "Focused on both taste and nutritional value",
      "Enjoyed together, without rules or guilt"
    ]
  },
  pricing: {
    dates: "5–8 November (3 nights / 4 days)",
    location: "Exmoor, Somerset",
    price: "£550 total",
    earlyBird: "Early booking offer: 10% off in March → £495",
    spaces: "Up to 11 guests (very limited, intimate group)",
    note: "This small group size allows for genuine connection, calm energy, and personal attention."
  },
  whyAttend: {
    title: "What You'll Experience",
    description: "This isn't about rigid schedules, intense workouts, or self-improvement pressure.",
    benefits: [
      "Letting your nervous system settle",
      "Feeling held by nature and good people",
      "Moving your body gently",
      "Laughing, resting, eating well, and breathing deeply"
    ],
    outcome: "You'll leave feeling emotionally lighter, mentally clearer, and deeply restored."
  },
  cta: {
    title: "Limited Spaces Available",
    description: "Spaces are limited and this retreat is intentionally intimate. If you feel drawn to it, the next step is simply to register your interest.",
    details: "I'll then personally send you: Full booking details, Exact accommodation breakdown, Next steps to secure your place"
  }
};

export const contactInfo = {
  phone: "+447787166065",
  whatsapp: "+447787166065",
  email: "Aaronchoi@acwellnessanddevelopment.com",
  location: "Portsmouth, United Kingdom",
  serviceAreas: ["Portsmouth", "Gosport", "Fareham", "Waterlooville", "Southsea", "Havant", "Eastleigh", "Southampton"]
};
